import pages from './pages';

const pageItems = {
    items: pages
};

export default pageItems;
